import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Link } from 'react-router-dom'
import styles from './index.module.css'

const EventDetail = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page padding pt_20">
			<div className={styles["detail-title"]}>
				<p>마이데이터 오픈 이벤트</p>
				<span>2021.12.05 ~ 2021.12.31</span>
			</div>
			<hr className="my_30" />
			<div className={styles["detail-content"]}>
				<p>
					이벤트내용 이벤트 내용
				</p>
			</div>
		</div>
	)
}

export default EventDetail
